module.exports = __webpack_public_path__ + "public/img/ico-charts-solar.51933487.svg";